import { useEffect, useState } from 'react';
import { api } from '../lib/api';

/**
 * §1bis.9 — embudo del alta (medición propia, sin terceros ni datos personales):
 * vistas → envíos → altas, y errores de validación con el campo más frecuente, por día y
 * origen (utm_source, si no el host del referrer, si no "directo").
 */
interface Row {
  day: string; origin: string; utmCampaign: string | null; views: number; submits: number;
  successes: number; validationErrors: number; topErrorField: string | null;
}

const FIELD_LABEL: Record<string, string> = {
  email: 'correo', password: 'contraseña', fullName: 'nombre', tenantName: 'negocio',
  acceptedLegal: 'términos', captcha: 'verificación', server: 'servidor', referralCode: 'referido',
};

export function SignupFunnelCard() {
  const [days, setDays] = useState(14);
  const [rows, setRows] = useState<Row[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    setErr(null);
    api<Row[]>(`/platform/signup-funnel?days=${days}`).then(setRows).catch(() => setErr('No se pudo cargar el embudo.'));
  }, [days]);

  const tot = (rows ?? []).reduce((a, r) => ({
    views: a.views + r.views, submits: a.submits + r.submits, successes: a.successes + r.successes,
    errors: a.errors + r.validationErrors,
  }), { views: 0, submits: 0, successes: 0, errors: 0 });
  const th = 'px-3 py-2 text-left text-[11px] font-medium uppercase tracking-[0.14em] text-slate-400';
  const td = 'px-3 py-2 text-sm text-slate-700';

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="text-sm font-medium text-slate-800">Embudo del alta</p>
          <p className="text-[11px] text-slate-500">Medición propia, sin terceros ni datos personales.</p>
        </div>
        <select value={days} onChange={(e) => setDays(Number(e.target.value))}
          className="rounded-lg border border-slate-200 px-2 py-1 text-xs">
          {[7, 14, 30, 90].map((d) => <option key={d} value={d}>Últimos {d} días</option>)}
        </select>
      </div>
      {err && <p className="text-sm text-rose-600">{err}</p>}
      {rows && (
        <>
          <p className="mb-3 text-xs text-slate-600">
            {tot.views} vistas · {tot.submits} envíos · <strong>{tot.successes} altas</strong> · {tot.errors} errores de validación
          </p>
          {rows.length === 0 ? <p className="text-sm text-slate-500">Sin eventos en el periodo.</p> : (
            <div className="overflow-x-auto">
              <table className="w-full min-w-[640px]">
                <thead><tr>
                  <th className={th}>Día</th><th className={th}>Origen</th><th className={th}>Campaña</th>
                  <th className={th}>Vistas</th><th className={th}>Envíos</th><th className={th}>Altas</th>
                  <th className={th}>Errores</th><th className={th}>Campo con más errores</th>
                </tr></thead>
                <tbody className="divide-y divide-slate-100">
                  {rows.map((r) => (
                    <tr key={`${r.day}|${r.origin}|${r.utmCampaign ?? ''}`}>
                      <td className={td}>{r.day}</td><td className={td}>{r.origin}</td><td className={td}>{r.utmCampaign ?? '—'}</td>
                      <td className={td}>{r.views}</td><td className={td}>{r.submits}</td><td className={td}>{r.successes}</td>
                      <td className={td}>{r.validationErrors}</td>
                      <td className={td}>{r.topErrorField ? (FIELD_LABEL[r.topErrorField] ?? r.topErrorField) : '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
}
